import React from 'react';
import { useFormContext } from 'react-hook-form';
import { RhNumberField } from '../../../../../../../../dum';
import { IOrderQuotation } from '../../../order-quotation-form';
import { useCalculateProductsTotal } from '../../../helpers/use-calculate-products-total';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

const ARRAY_NAME: keyof IOrderQuotation = 'order_quotation_products';
const GROUPS_FIELD_NAME: keyof IOrderQuotation['order_quotation_products'][number] =
    'groups';
const KILOS_FIELD_NAME: keyof IOrderQuotation['order_quotation_products'][number] =
    'kilos';
const GROUP_WEIGHT_FIELD_NAME: keyof IOrderQuotation['order_quotation_products'][number] =
    'group_weight';

interface IGroupsInputProps {
    index: number;
}

export function GroupsInput({ index }: IGroupsInputProps) {
    const INPUT_NAME = `${ARRAY_NAME}.${index}.${GROUPS_FIELD_NAME}`;

    const formContext = useFormContext();
    const { calculateProductsTotal } = useCalculateProductsTotal();

    return (
        <RhNumberField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.groups)}
            disableGutters
            onChange={(groups) => {
                const groupWeight = formContext.getValues(
                    `${ARRAY_NAME}.${index}.${GROUP_WEIGHT_FIELD_NAME}`,
                ) as IOrderQuotation['order_quotation_products'][number]['group_weight'];
                if (!!groupWeight) {
                    formContext.setValue(
                        `${ARRAY_NAME}.${index}.${KILOS_FIELD_NAME}`,
                        (groups ? Number(groups) : 0) * groupWeight,
                    );
                }
                calculateProductsTotal();
            }}
        />
    );
}
